const footwear = [
  {title: "Boots",icon: "icon1",subcategories: []},
  {title: "Casual Leather",icon: "icon2",subcategories: []},
  {title: "Formal",icon: "icon2",subcategories: []},
  {title: "Sneakers",icon: "icon2",subcategories: []},
  {title: "Sandals",icon: "icon2",subcategories: []},
  {title: "Slip-Ons",icon: "icon2",subcategories: []},
]
export default footwear;
